import React, { useState } from "react";
import { Form, Modal, Button, Container, Row, Col } from "react-bootstrap";
import TextField from "Components/Fields/TextField";
import Loading from "Components/Loading";
import { Regexes } from "Utils/Regexes";
import { Validators } from "Utils/Constants";
import editWhite from "Assets/Icons/edit-white.svg";

import "./Manual.scss";

const Manaul = ({ onDataChanged, plaidDefault, enrollmentStep }) => {
  const [submitted, setSubmitted] = useState(false);
  const [formState, setFormState] = useState({
    routingNumber: { fieldValue: "", isValid: false },
    accountNumber: { fieldValue: "", isValid: false },
  });

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onFieldChange = (fieldName, fieldValue, isValid) => {
    setFormState((prevState) => {
      return { ...prevState, [fieldName]: { fieldValue, isValid } };
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    await onDataChanged({
      routingNumber: formState.routingNumber.fieldValue,
      accountNumber: formState.accountNumber.fieldValue,
    });
  };

  const proceed = Object.values(formState).every(
    (field) => field.isValid === true
  );

  const style = {
    width: "100%",
    marginTop: "20px",
    marginBottom: "20px",
  };
  return (
    <>
      {(!plaidDefault || !enrollmentStep) && (
        <div className="funding-source click-add-manual">
          <Button className="ready click-add-manual" onClick={handleShow}>
            <img className="bank-icon click-add-manual" src={editWhite} alt="Bank Icon"></img>
            <div className="bank-label click-add-manual">MANUALLY ENTER BANK INFO</div>
          </Button>
        </div>
      )}
      {plaidDefault && enrollmentStep && (
        <div className="text-center" style={style}>
          <button className="link text-center click-add-manual" onClick={handleShow}>
            manually enter your bank information
          </button>
        </div>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="manual-payment"
        animation={false}
      >
        {submitted ? (
          <Loading style={{ "margin-top": "200px" }} />
        ) : (
          <>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <Form onSubmit={onSubmit}>
                <Container>
                  <Row>
                    <div className="title">Manual Entry</div>
                  </Row>
                  <Row>
                    <Col className="text-center bank-text">
                      Enter your bank account <br /> credentials below
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextField
                        fieldName="accountNumber"
                        label="ACCOUNT NUMBER"
                        maxLength={17}
                        required={true}
                        allowedCharacters={Regexes.NUMBER}
                        validators={[
                          Validators.NUMBERS_ONLY,
                          Validators.BANK_ACCOUNT_LENGTH,
                        ]}
                        onValueChanged={onFieldChange}
                        autoComplete="off"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextField
                        fieldName="routingNumber"
                        label="ROUTING NUMBER"
                        maxLength={9}
                        required={true}
                        allowedCharacters={Regexes.NUMBER}
                        validators={[
                          Validators.NUMBERS_ONLY,
                          Validators.ROUTING_NUMBER_LENGTH,
                        ]}
                        onValueChanged={onFieldChange}
                        autoComplete="off"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <button
                        type="submit"
                        disabled={!proceed}
                        className={
                          (proceed ? "submit-button" : "submit-button disabled") + "  click-add-manual-submit"
                        }
                      >
                        DONE
                      </button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  );
};
export default Manaul;
